import { render, staticRenderFns } from "./Ventas_Aseguradora.vue?vue&type=template&id=47e6da56&scoped=true&"
import script from "./Ventas_Aseguradora.vue?vue&type=script&lang=js&"
export * from "./Ventas_Aseguradora.vue?vue&type=script&lang=js&"
import style0 from "./Ventas_Aseguradora.vue?vue&type=style&index=0&id=47e6da56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6da56",
  null
  
)

export default component.exports